module.exports = __webpack_public_path__ + "img/soccer.18cd3fb7.svg";